import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const AssetRefreshIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12 2C14.4 2 16.8 2.8 16.8 5.2C16.8 7.6 14.4 8.4 12 8.4C9.6 8.4 7.2 7.6 7.2 5.2C7.2 2.8 9.6 2 12 2ZM16.8 5.2V9.6C16.8 12 14.4 12.8 12 12.8C9.6 12.8 7.2 12 7.2 9.6V5.2M16.8 9.6V14C16.8 16.4 14.4 17.2 12 17.2C9.6 17.2 7.2 16.4 7.2 14V9.6"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
    <path
      d="M18 17L16 19L14 17M14 21L16 19L18 21"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
  </svg>
);

AssetRefreshIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(AssetRefreshIcon);
